'use strict'
module.exports = {
  Blake224: require('./blake224'),
  Blake256: require('./blake256'),
  Blake384: require('./blake384'),
  Blake512: require('./blake512')
}
